Vue.component('search-list-item', {
  template: '#vue-search-list-item',
  props: ['item', 'adults', 'childrens', 'age_child_1', 'age_child_2', 'age_child_3', 'age_child_4'],
  data: function () {
    return {
      detailsQuery: {},
      classPromocja: '',
      srcset: {}
    }
  },
  created: function () {
    const self = this;

    if (typeof self.item.startDate !== 'undefined' && self.item.startDate && self.item.startDate != "default") self.detailsQuery.start_date = self.item.startDate;
    if (typeof self.item.endDate !== 'undefined' && self.item.endDate && self.item.endDate != "default") self.detailsQuery.end_date = self.item.endDate;
    if (typeof self.item.mw !== 'undefined' && self.item.mw && self.item.mw != "default") self.detailsQuery.mw = self.item.mw;

    if (typeof self.adults !== 'undefined' && self.adults != "default") self.detailsQuery.adults = self.adults;
    if (typeof self.childrens !== 'undefined' && self.childrens != "default") self.detailsQuery.childrens = self.childrens;

    if (typeof self.age_child_1 !== 'undefined' && self.age_child_1 && self.age_child_1 != "default") self.detailsQuery.age_child_1 = self.age_child_1;
    if (typeof self.age_child_2 !== 'undefined' && self.age_child_2 && self.age_child_2 != "default") self.detailsQuery.age_child_2 = self.age_child_2;
    if (typeof self.age_child_3 !== 'undefined' && self.age_child_3 && self.age_child_3 != "default") self.detailsQuery.age_child_3 = self.age_child_3;
    if (typeof self.age_child_4 !== 'undefined' && self.age_child_4 && self.age_child_4 != "default") self.detailsQuery.age_child_4 = self.age_child_4;

    if (self.item.room === '') self.item.room = '-';

    if (self.item.discountType) {
      self.classPromocja = 'bg-promocja-' + self.item.discountType;
    }

    let srcset = {};
    if (typeof self.item.img !== 'undefined' && self.item.img !== null && typeof self.item.img.url2 !== 'undefined' && self.item.img.url2 !== null && self.item.img.url2 !== '') {
      // srcset.s = self.item.img.url2.replace(/\.([^\.]*)$/,'s.$1');
      srcset.l = self.item.img.url2.replace(/\.([^\.]*)$/, 'l.$1');
    }
    self.srcset = srcset;
  }
});

Vue.component('search-list', {
  template: '#vue-search-list',
  data: function () {
    return {
      adults: '',
      childrens: '',
      age_child_1: '',
      age_child_2: '',
      age_child_3: '',
      age_child_4: '',
      listItems: [],
      moreButton: false,
      sort_order: '',
      config: {
        sort_order: [
          { text: locales('components.search-list.js.sort.default'), value: "default" },
          { text: locales('components.search-list.js.sort.price_asc'), value: "price-asc" },
          { text: locales('components.search-list.js.sort.price_desc'), value: "price-desc" },
          { text: locales('components.search-list.js.sort.standard_asc'), value: "stars-asc" },
          { text: locales('components.search-list.js.sort.standard_desc'), value: "stars-desc" },
          { text: locales('components.search-list.js.sort.name_asc'), value: "name-asc" },
          { text: locales('components.search-list.js.sort.name_desc'), value: "name-desc" }
        ]
      },
      error: 0
    }
  },
  created: function () {
    const self = this;
    serverBus.$on('errorSearch', function (code) {
      self.error = code;
    });
    serverBus.$on('search_done', function (data) {
      if (self.listItems.length == 0 && data.result.items.length == 0) {
        serverBus.errorReturn('search', 1);
      } else serverBus.errorReturn('search', 0);

      for (let i = 0, len = data.result.items.length; i < len; i++) {
        self.listItems.push(data.result.items[i]);
      }
      self.moreButton = data.result.isMore;

      self.adults = data.params.adults;
      self.childrens = data.params.childrens;
      self.age_child_1 = data.params.age_child_1;
      self.age_child_2 = data.params.age_child_2;
      self.age_child_3 = data.params.age_child_3;
      self.age_child_4 = data.params.age_child_4;
    });
    serverBus.$on('search_clear', function () {
      self.listItems = [];
      self.moreButton = false;
    });
  },
  watch: {
    'sort_order': function (newSort, oldSort) {
      console.log(oldSort, newSort);
      if (oldSort != '' && newSort != oldSort) {
        serverBus.$emit('search_change_order', { sort_order: newSort });
      }
    }
  },
  methods: {
    moreOffers: function () {
      serverBus.$emit('search_more');
    }
  },
  mounted: function () {
    const self = this;

    if (self.$route.query.hasOwnProperty('sort_order') && self.$route.query['sort_order'] != "") {
      self.sort_order = self.$route.query['sort_order'];
    } else {
      self.sort_order = 'default';
    }

    $('.container-search-adv').on({ // document
      mouseenter: function () {
        $(this).closest(".search-list-item-row").find('a.to-offer-details').addClass('hover')
      },
      mouseleave: function () {
        $(this).closest(".search-list-item-row").find('a.to-offer-details').removeClass('hover')
      }
    }, ".search-list-item-row a.to-offer-details");
  }
});